import { DocumentProcessStatusEnum } from 'common/document/enums/document-status.enum';

export const FOCUS_ERROR_MESSAGE = {
  label: 'Out of Focus',
  message: 'Make sure document is in focus before taking photo.',
};

export const PREDEFINED_ERROR_MESSAGES = {
  [DocumentProcessStatusEnum.FAILED]: {
    label: 'Failed',
    message: 'Please, try later.',
  },
};
